<template>
  <v-layout alig-start>
    <v-flex>
      <!-- Inicio de barra de alerta -->
      <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false"
        transition="slide-y-reverse-transition" right>{{ alerta.text }}</v-snackbar>
      <!-- Fin inicio de barra de alerta -->

      <!-- Listado de repuestos y opciones de titulo, busqueda, nuevo, etc  -->
      <v-data-table :loading="loading" :headers="headers" :items="repuestos" :items-per-page="15" item-key="idrepuesto"
        show-expand class="elevation-3" dense>
        <!-- Llenamos datos en data table -->
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="hidden-sm-and-down">REPUESTOS</v-toolbar-title>
            <v-divider class="mx-2 hidden-sm-and-down" inset vertical></v-divider>
            <!-- Impresion repuesto pdf y excel -->
            <v-btn fab x-small color="info" @click="crearPDF()" :loading="loading" :disabled="loading" class="mr-1">
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn fab x-small color="success" @click="crearXLSX()" :loading="loading" :disabled="loading" class="mr-1">
              <v-icon>description</v-icon>
            </v-btn>
            <!-- Fin impresion repuesto pdf y excel -->
            <v-spacer />
            <!-- Formulario busqueda de repuesto -->
            <v-text-field class="text-xs-center" v-model.trim="buscar" outlined dense label="Búsqueda"
              background-color="blue lighten-5" single-line @keyup="listar" hide-details></v-text-field>
            <!-- Fin Formulario busqueda de repuesto -->
            <v-spacer />

            <v-switch v-model="todoRepuestos" inset hide-details @click="listar" label="Todo" class="ml-2"></v-switch>
            <v-spacer />
            <!-- Modal crear y mofificar repuesto -->
            <v-dialog v-model="dialog" max-width="900px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" class="ma-2" v-on="on" small>Nuevo</v-btn>
              </template>
              <v-card>
                <v-tabs v-model="tab" background-color="primary" dark>
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab href="#tab-1">{{ formTitle }}</v-tab>
                  <v-tab href="#tab-2">Imagen</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <v-tab-item value="tab-1">
                    <v-card flat>
                      <v-card-text>
                        <v-form v-model="isValid">
                          <v-row no-gutters>
                            <v-col cols="12" md="4" sm="4">
                              <v-text-field outlined dense v-model.trim="codigo_repuesto" label="Código Repuesto"
                                :rules="[v => !!v || 'Codigo de repuesto es requerido', v => (v && v.length >= 3 && v.length <= 30) || 'Cod. de repuesto debe tener de 3 a 30 caracteres', Rules.unespacio]"
                                maxlength="30" background-color="blue lighten-5" class="pr-1" v-uppercase>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="4">
                              <v-text-field outlined dense v-model.trim="codigo_equivalencia"
                                label="Código Equivalencia"
                                :rules="[v => v.length <= 30 || 'El codigo no debe exceder los 30 caracteres', Rules.unespacio]"
                                maxlength="30" background-color="blue lighten-5" class="pr-1" v-uppercase>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="4">
                              <v-text-field outlined dense v-model.trim="codigo_barra" label="Código Barras"
                                :rules="[v => v.length <= 30 || 'El código de barra no debe tener mas de 30 caracteres',Rules.sinespacio]"
                                maxlength="30" background-color="blue lighten-5"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-autocomplete outlined dense :items="unidad_medidas" v-model="idunidad_medida"
                                label="Unidad Medida" :rules="[v => !!v || 'La unidad de medida es requerido']"
                                background-color="blue lighten-5" class="pr-1" required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-autocomplete outlined dense :items="categorias" v-model="idcategoria" label="Categoría"
                                :rules="[v => !!v || 'La categoría es requerido']" background-color="blue lighten-5"
                                class="pr-1" required></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-autocomplete outlined dense :items="marca_repuestos" v-model="idmarca_repuesto"
                                label="Marca Repuesto" :rules="[v => !!v || 'La marca de repuesto es requerido']"
                                background-color="blue lighten-5" class="pr-1"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-autocomplete outlined dense :items="marca_vehiculos" v-model="idmarca_vehiculo"
                                label="Marca Vehículo" :rules="[v => !!v || 'La marca de vehículo es requerido']"
                                background-color="blue lighten-5" class="pr-1"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="5" sm="4">
                              <v-text-field outlined dense v-model.trim="compatibilidad" label="Modelos" maxlength="100"
                                background-color="blue lighten-5" prepend-inner-icon="short_text" v-uppercase
                                class="pr-1"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                              <v-autocomplete outlined dense :items="formas" v-model="idforma" label="Tipo"
                                :rules="[v => !!v || 'El tipo es requerido']" background-color="blue lighten-5"
                                class="pr-1"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3">
                              <v-autocomplete outlined dense :items="materiales" v-model="idmaterial" label="Material"
                                :rules="[v => !!v || 'El material es requerido']" background-color="blue lighten-5"
                                class="pr-1"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="3" sm="2">
                              <v-autocomplete outlined dense :items="giros" v-model="idgiro" label="Giro"
                                :rules="[v => !!v || 'El giro es requerido']" background-color="blue lighten-5"
                                class="pr-1"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                              <v-text-field outlined dense v-model.trim="procedencia" label="Procedencia"
                                :rules="[v => v.length <= 50 || 'La procedencia no debe tener mas de 50 caracteres', Rules.unespacio]"
                                maxlength="50" background-color="blue lighten-5" v-uppercase class="pr-1">
                              </v-text-field>
                            </v-col>
                            <v-col cols="4" md="2" sm="2">
                              <v-text-field outlined dense v-model.trim="interior" label="INT"
                                :rules="[v => v.length <= 8 || 'El interior no debe exceder los 8 caracteres', Rules.sinespacio]"
                                maxlength="8" background-color="blue lighten-5" class="pr-1" v-uppercase></v-text-field>
                            </v-col>
                            <v-col cols="4" md="2" sm="2">
                              <v-text-field outlined dense v-model.trim="exterior" label="EXT"
                                :rules="[ v => v.length <= 12 || 'El exterior no debe exceder los 12 caracteres', Rules.sinespacio]"
                                maxlength="12" background-color="blue lighten-5" class="pr-1" v-uppercase>
                              </v-text-field>
                            </v-col>
                            <v-col cols="4" md="2" sm="2">
                              <v-text-field outlined dense v-model.trim="altura" label="ALT"
                                :rules="[v => v.length <= 12 || 'La altura no debe exceder los 12 caracteres', Rules.sinespacio]"
                                maxlength="12" background-color="blue lighten-5" class="pr-1" v-uppercase>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field outlined dense v-model.trim="descripcion" label="Descripción"
                                :rules="[v => v.length <= 40 || 'La descripción no debe tener mas de 40 caracteres', Rules.unespacio]"
                                maxlength="40" background-color="blue lighten-5" prepend-inner-icon="notes" v-uppercase>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" sm="10">
                              <v-autocomplete outlined dense @keyup="selectProdSunat()"
                                :search-input.sync="buscar_prodsunat" v-model="idprod_sunat" :items="prod_sunats"
                                label="Producto Sunat" :rules="[v => !!v || 'El producto es requerido']"
                                background-color="blue lighten-5" class="mr-1" clearable></v-autocomplete>
                            </v-col>
                            <v-col cols="4" md="2" sm="2">
                              <v-text-field type="text" outlined dense v-model="stock_minimo" label="Stock Min."
                                :rules="[v => (!!v && v > 0) || 'Requerido']" maxlength="5"
                                background-color="red lighten-5" v-mask-number></v-text-field>
                            </v-col>
                          </v-row>
                          <v-container>
                            <v-toolbar-title class="mb-1 primary--text">Precios de compra</v-toolbar-title>
                            <v-row no-gutters>
                              <v-col cols="6" md="3" sm="3">
                                <v-text-field type="text" outlined dense v-model="precio_unit_comprad"
                                  label="P/U Compra $" :rules="[v => (!!v && v > 0) || 'Requerido']" maxlength="9"
                                  background-color="green lighten-5" v-mask-decimal.us="4" class="pr-1"
                                  @keyup.prevent="precio_unit_compras = roundOut((parseFloat(precio_unit_comprad)*tc),4).toFixed(4)"
                                  @keyup.native="precio_publico=calcularPP, precio_tiendas=calcularPT, precio_distribuidor=calcularPD"
                                  hide-details></v-text-field>
                              </v-col>
                              <v-col cols="6" md="3" sm="3">
                                <v-text-field type="text" outlined dense v-model="precio_unit_compras"
                                  label="P/U Compra S/" :rules="[v => (!!v && v > 0) || 'Requerido']" maxlength="9"
                                  background-color="blue lighten-5" class="pr-1"
                                  @keyup.prevent="precio_unit_comprad = roundOut((parseFloat(precio_unit_compras)/tc),4).toFixed(4)"
                                  @keyup.native="precio_publico=calcularPP, precio_tiendas=calcularPT, precio_distribuidor=calcularPD"
                                  v-mask-decimal.us="4" hide-details></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                          <v-container>
                            <v-toolbar-title class="mb-1 primary--text">Precios de venta</v-toolbar-title>
                            <v-row no-gutters>
                              <v-col cols="6" md="2" sm="2">
                                <v-text-field type="text" outlined dense v-model="utilidad_publico"
                                  label="Utilidad Publico" :rules="[v => (!!v && v > 0) || 'Requerido']" suffix="%"
                                  maxlength="9" background-color="grey lighten-5" v-mask-decimal.us="4" class="pr-1"
                                  @keyup.prevent="precio_publico = roundOut((parseFloat(precio_unit_compras) + parseFloat(precio_unit_compras) * parseFloat(utilidad_publico)/100),2).toFixed(2)">
                                </v-text-field>
                              </v-col>
                              <v-col cols="6" md="2" sm="2">
                                <v-text-field type="text" outlined dense v-model="precio_publico"
                                  label="P/U/Vent. Público" :rules="[v => (!!v && v > 0) || 'Requerido']" maxlength="9"
                                  background-color="blue lighten-5" v-mask-decimal.us="2" class="pr-1"
                                  @keyup.prevent="utilidad_publico = roundOut((((parseFloat(precio_publico) - parseFloat(precio_unit_compras)) / parseFloat(precio_unit_compras)) * 100),4).toFixed(4)">
                                </v-text-field>
                              </v-col>

                              <v-col cols="6" md="2" sm="2">
                                <v-text-field type="text" outlined dense v-model="utilidad_tiendas"
                                  label="Utilidad Tiendas" :rules="[v => (!!v && v > 0) || 'Requerido']" suffix="%"
                                  maxlength="9" background-color="grey lighten-5" v-mask-decimal.us="4" class="pr-1"
                                  @keyup.prevent="precio_tiendas = roundOut((parseFloat(precio_unit_compras) + parseFloat(precio_unit_compras) * parseFloat(utilidad_tiendas)/100),2).toFixed(2)">
                                </v-text-field>
                              </v-col>
                              <v-col cols="6" md="2" sm="2">
                                <v-text-field type="text" outlined dense v-model="precio_tiendas"
                                  label="P/U/Vent. Tiendas" :rules="[v => (!!v && v > 0) || 'Requerido']" maxlength="9"
                                  background-color="blue lighten-5" v-mask-decimal.us="2" class="pr-1"
                                  @keyup.prevent="utilidad_tiendas = roundOut((((parseFloat(precio_tiendas) - parseFloat(precio_unit_compras)) / parseFloat(precio_unit_compras)) * 100),4).toFixed(4)">
                                </v-text-field>
                              </v-col>

                              <v-col cols="6" md="2" sm="2">
                                <v-text-field type="text" outlined dense v-model="utilidad_distribuidor"
                                  label="Utilidad Distribuidor" :rules="[v => (!!v && v > 0) || 'Requerido']" suffix="%"
                                  maxlength="9" background-color="grey lighten-5" v-mask-decimal.us="4" class="pr-1"
                                  @keyup.prevent="precio_distribuidor = roundOut((parseFloat(precio_unit_compras) + parseFloat(precio_unit_compras) * parseFloat(utilidad_distribuidor)/100),2).toFixed(2)">
                                </v-text-field>
                              </v-col>
                              <v-col cols="6" md="2" sm="2">
                                <v-text-field type="text" outlined dense v-model="precio_distribuidor"
                                  label="P/U/Vent. Distribuidor" :rules="[v => (!!v && v > 0) || 'Requerido']"
                                  maxlength="9" background-color="blue lighten-5" v-mask-decimal.us="2"
                                  @keyup.prevent="utilidad_distribuidor = roundOut((((parseFloat(precio_distribuidor) - parseFloat(precio_unit_compras)) / parseFloat(precio_unit_compras)) * 100),4).toFixed(4)">
                                </v-text-field>
                              </v-col>
                              <!-- Mensaje error repuesto -->
                              <v-col cols="12" v-if="mensajeRepuesto !=''">
                                <v-alert text dense type="error">{{mensajeRepuesto}}</v-alert>
                              </v-col>
                              <!-- Mensaje error repuesto -->
                            </v-row>
                          </v-container>
                        </v-form>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="tab-2">
                    <v-card flat>
                      <v-card-text>
                        <v-row class="mt-2">
                          <v-col cols="12" sm="6" align="center">
                            <template color="teal" v-if="file">
                              <v-avatar tile size="160">
                                <v-img :src="urlTemporal" @click="$refs.boton.click()" />
                              </v-avatar>
                            </template>
                            <template v-else-if="imagen==''">
                              <v-avatar tile size="160">
                                <img :src="'data:image/png;base64,'+imagenxdefec" @click="$refs.boton.click()" />
                              </v-avatar>
                            </template>
                            <template color="teal" v-else>
                              <v-avatar tile size="160">
                                <img :src="'data:image/png;base64,'+imagen" @click="$refs.boton.click()" />
                              </v-avatar>
                            </template>
                            <input type="file" id="file" ref="boton" accept=".png, .jpg, .jpeg"
                              @change="buscarImagen($event)" class="d-none" />
                          </v-col>
                          <!-- Codigo barra  -->
                          <v-col cols="12" sm="5" align="center">
                            <barcode v-if="codigo_barra.length==13" :value="codigo_barra" format="EAN13" font-size="12"
                              height="53" width="2" id="print">Código no es EAN13</barcode>
                            <barcode v-else-if="codigo_barra.length==8" :value="codigo_barra" font-size="12"
                              format="EAN8" height="53" width="2" id="print">Código no es EAN8</barcode>
                            <barcode v-else :value="codigo_barra" font-size="12" height="53" width="2" id="print">
                            </barcode>
                          </v-col>
                          <!-- Fin codigo barra -->
                          <v-col cols="1" sm="1">
                            <v-btn icon @click="imprimirBarcode()">
                              <v-icon>print</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>

                <v-card-actions class="py-0 pb-3 justify-center">
                  <v-btn color="error" @click="close" small>
                    <v-icon left>cancel</v-icon>Cancelar
                  </v-btn>
                  <v-btn color="primary" @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid"
                    small>
                    <v-icon left>save</v-icon>Guardar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- Fin Modal crear y mofificar repuesto -->

            <!-- Modal activar y desactivar repuesto -->
            <v-dialog v-model="adModal" max-width="295">
              <v-card>
                <v-card-title class="headline" v-if="adAccion==1">¿Activar Repuesto?</v-card-title>
                <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Repuesto?</v-card-title>
                <v-card-text>
                  Estás a punto de
                  <span v-if="adAccion==1">Activar</span>
                  <span v-if="adAccion==2">Desactivar</span>
                  el codigo de repuesto {{ adNombre }}
                </v-card-text>
                <v-card-actions class="py-0 pb-4 justify-center">
                  <v-btn color="green darken-1" @click="activarDesactivarCerrar" small>Cancelar</v-btn>
                  <v-btn v-if="adAccion==1" color="orange darken-4" @click="activar" small>Activar</v-btn>
                  <v-btn v-if="adAccion==2" color="orange darken-4" @click="desactivar" small>Desactivar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- Fin Modal activar y desactivar repuesto -->
          </v-toolbar>
        </template>

        <template v-slot:item.fecha_modificacion="{ item }">
          <span>{{ item.fecha_modificacion | formatearFechaHm }}</span>
        </template>

        <!-- Opciones editar, eliminar -->
        <template v-slot:item.imagen="{ item }">
          <template>
            <v-avatar tile size="30">
              <img :src="'data:image/png;base64,'+item.imagen" />
            </v-avatar>
          </template>
        </template>

        <template v-slot:item.condicion="{ item }">
          <template v-if="item.condicion">
            <v-btn rounded x-small color="success" @click="activarDesactivarMostrar(2,item)">Activo</v-btn>
          </template>
          <template v-else>
            <v-btn rounded x-small color="orange darken-2" @click="activarDesactivarMostrar(1,item)">Inactivo</v-btn>
          </template>
        </template>

        <template v-slot:item.opciones="{ item }">
          <v-btn small icon>
            <v-icon color="blue darken-2" @click="editItem(item)">edit</v-icon>
          </v-btn>
          <v-btn small icon>
            <v-icon color="red darken-2" @click="deleteItem(item)">delete_forever</v-icon>
          </v-btn>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <strong>Descripción:</strong>
            {{ item.descripcion }}
            <strong>Modelos:</strong>
            {{ item.compatibilidad }}
            <strong>Procedencia:</strong>
            {{ item.procedencia }}
          </td>
        </template>

        <!-- Fin Opciones editar, eliminar -->
      </v-data-table>
      <!-- Fin Listado de repuestos y opciones de titulo, busqueda, nuevo, etc -->
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import XLSX from "xlsx";
import PrintArea from "print-area";
import VueBarcode from "vue-barcode";
import { mapState } from "vuex";

export default {
  data() {
    return {
      repuestos: [],
      dialog: false,
      headers: [
        { text: "", value: "data-table-expand" },
        { text: "", value: "imagen", align: "center", sortable: false },
        { text: "CÓD.REPUESTO", value: "codigo_repuesto", sortable: false , width: 135 },
        { text: "CATEGORÍA", value: "categoria", sortable: false  },
        { text: "MARCA", value: "marca_repuesto", sortable: false  },
        //{ text: "TIPO", value: "forma" },
        //{ text: "MATERIAL", value: "material" },
        //{ text: "GIRO", value: "giro" },
        { text: "INT", value: "interior", sortable: false  },
        { text: "EXT", value: "exterior", sortable: false  },
        //{ text: "ALT", value: "altura" },
        { text: "FEC.MODIF.", value: "fecha_modificacion", sortable: false  },
        { text: "CONDICIÓN", align: "center", value: "condicion", sortable: false, },
        { text: "OPCIÓN", value: "opciones", sortable: false },
      ],

      buscar: "",
      editedIndex: -1,

      idrepuesto: "",
      idcategoria: "",
      categorias: [],
      idmarca_repuesto: "",
      marca_repuestos: [],
      idmarca_vehiculo: "",
      marca_vehiculos: [],
      idunidad_medida: "",
      unidad_medidas: [],
      idforma: "",
      formas: [],
      idmaterial: "",
      materiales: [],
      idgiro: "",
      giros: [],
      imagen: "",
      codigo_barra: "",
      codigo_repuesto: "",
      codigo_equivalencia: "",
      interior: "",
      exterior: "",
      altura: "",
      stock_minimo: "",

      descripcion: "",
      compatibilidad: "",
      procedencia: "",
      idprod_sunat: "", // prod_sunats
      precio_unit_compras: (0).toFixed(4),
      precio_unit_comprad: (0).toFixed(4),
      utilidad_publico: (0).toFixed(4),
      precio_publico: (0).toFixed(2),
      utilidad_tiendas: (0).toFixed(4),
      precio_tiendas: (0).toFixed(2),
      utilidad_distribuidor: (0).toFixed(4),
      precio_distribuidor: (0).toFixed(2),

      prod_sunats: [],

      buscar_prodsunat: "",

      todoRepuestos: false,

      igv: 0,
      tc: 0,

      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      file: null,
      urlTemporal: "",
      mensajeRepuesto: "",

      desabilitar: false,
      isValid: true,

      alerta: { snackbar: false, color: "", text: "" },

      tab: null,

      imagenxdefec:
        "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",

      Rules: {
        sinespacio: (v) => (v || "").indexOf(" ") < 0 || "Sin espacios",
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },
  components: {
    barcode: VueBarcode,
  },

  computed: {
    ...mapState(["logo", "datos"]),

    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Repuesto" : "Actualizar Repuesto";
    },

    calcularPP() {
      return this.roundOut(
        parseFloat(this.precio_unit_compras) +
        (parseFloat(this.precio_unit_compras) *
          parseFloat(this.utilidad_publico)) /
        100,
        2
      ).toFixed(2);
    },
    calcularPT() {
      return this.roundOut(
        parseFloat(this.precio_unit_compras) +
        (parseFloat(this.precio_unit_compras) *
          parseFloat(this.utilidad_tiendas)) /
        100,
        2
      ).toFixed(2);
    },
    calcularPD() {
      return this.roundOut(
        parseFloat(this.precio_unit_compras) +
        (parseFloat(this.precio_unit_compras) *
          parseFloat(this.utilidad_distribuidor)) /
        100,
        2
      ).toFixed(2);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    precio_unit_comprad(newVal) {
      if (newVal === "" || newVal === null) {
        this.precio_unit_comprad = (0).toFixed(4);
      }
    },
    precio_unit_compras(newVal) {
      if (newVal === "" || newVal === null) {
        this.precio_unit_compras = (0).toFixed(4);
      }
    },

    utilidad_publico(newVal) {
      if (newVal === "" || newVal === null) {
        this.utilidad_publico = (0).toFixed(4);
      }
    },
    utilidad_tiendas(newVal) {
      if (newVal === "" || newVal === null) {
        this.utilidad_tiendas = (0).toFixed(4);
      }
    },
    utilidad_distribuidor(newVal) {
      if (newVal === "" || newVal === null) {
        this.utilidad_distribuidor = (0).toFixed(4);
      }
    },
    precio_publico(newVal) {
      if (newVal === "" || newVal === null) {
        this.precio_publico = (0).toFixed(2);
      }
    },
    precio_tiendas(newVal) {
      if (newVal === "" || newVal === null) {
        this.precio_tiendas = (0).toFixed(2);
      }
    },
    precio_distribuidor(newVal) {
      if (newVal === "" || newVal === null) {
        this.precio_distribuidor = (0).toFixed(2);
      }
    },
  },

  created() {
    this.listar();
    this.select();
    this.igv = parseFloat(this.datos.igv);
    this.tc = parseFloat(this.datos.tc);
  },

  methods: {
    roundOut: function (numero, dec) {
      let entero = Math.round(Number(numero + "e+" + dec));
      let redondear = Number(entero + "e-" + dec);
      return redondear;
    },

    imprimirBarcode() {
      const print = new PrintArea("#print");
      print.print();
    },

    listar() {
      let me = this;
      me.loading = true; // Habilitamos loading para datatable, botones de impresion y excel

      axios
        .get("api/Repuestos/Listar", {
          params: {
            buscar: me.buscar == "" ? "-" : me.buscar,
            todo: me.todoRepuestos,
          },
        })

        .then(function (response) {
          me.repuestos = response.data;
          me.loading = false;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    select() {
      let me = this;
      var categoriasArray = [];
      axios
        .get("api/Categorias/Select")
        .then(function (response) {
          categoriasArray = response.data;
          categoriasArray.map(function (x) {
            me.categorias.push({ text: x.nombre, value: x.idcategoria });
          });
        })
        .catch(function (error) { });

      let mr = this;
      var marca_repuestosArray = [];
      axios
        .get("api/Marca_Repuestos/Select")
        .then(function (response) {
          marca_repuestosArray = response.data;
          marca_repuestosArray.map(function (x) {
            mr.marca_repuestos.push({
              text: x.nombre,
              value: x.idmarca_repuesto,
            });
          });
        })
        .catch(function (error) { });

      let ve = this;
      var marca_vehiculosArray = [];
      axios
        .get("api/Marca_Vehiculos/Select")
        .then(function (response) {
          marca_vehiculosArray = response.data;
          marca_vehiculosArray.map(function (x) {
            ve.marca_vehiculos.push({
              text: x.nombre,
              value: x.idmarca_vehiculo,
            });
          });
        })
        .catch(function (error) { });

      let um = this;
      var unidad_medidasArray = [];
      axios
        .get("api/Unidad_Medidas/Select")
        .then(function (response) {
          unidad_medidasArray = response.data;
          unidad_medidasArray.map(function (x) {
            um.unidad_medidas.push({
              text: x.nombre,
              value: x.idunidad_medida,
            });
          });
        })
        .catch(function (error) { });

      let t = this;
      var formasArray = [];
      axios
        .get("api/formas/Select")
        .then(function (response) {
          formasArray = response.data;
          formasArray.map(function (x) {
            t.formas.push({
              text: x.prefijo,
              value: x.idforma,
            });
          });
        })
        .catch(function (error) { });

      let m = this;
      var materialesArray = [];
      axios
        .get("api/Materiales/Select")
        .then(function (response) {
          materialesArray = response.data;
          materialesArray.map(function (x) {
            m.materiales.push({
              text: x.prefijo,
              value: x.idmaterial,
            });
          });
        })
        .catch(function (error) { });

      let g = this;
      var girosArray = [];
      axios
        .get("api/Giros/Select")
        .then(function (response) {
          girosArray = response.data;
          girosArray.map(function (x) {
            g.giros.push({
              text: x.prefijo,
              value: x.idgiro,
            });
          });
        })
        .catch(function (error) { });
    },

    selectProdSunat(id) {
      let me = this;
      var prodSunatArray = [];

      let url = "";
      if (id) {
        url = "api/Prod_Sunats/SelectProductosSunat/" + id;
      } else {
        url =
          "api/Prod_Sunats/SelectProductosSunatFiltro?buscar=" +
          (me.buscar_prodsunat == "" ? "-" : me.buscar_prodsunat); // si el valor es vacio lo cambiamos a -
      }

      axios
        .get(url)
        .then(function (response) {
          prodSunatArray = response.data;
          prodSunatArray.map(function (x) {
            me.prod_sunats.push({
              text: x.idprod_sunat + " " + x.descripcion,
              value: x.idprod_sunat,
            });
          });
        })
        .then((data) => {
          this.changeCliente(id);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    guardar() {
      let me = this;
      me.desabilitar = true;

      if (me.editedIndex > -1) {
        axios
          .put("api/Repuestos/Actualizar", {
            idrepuesto: me.idrepuesto,
            idcategoria: me.idcategoria,
            idmarca_repuesto: me.idmarca_repuesto,
            idmarca_vehiculo: me.idmarca_vehiculo,
            idunidad_medida: me.idunidad_medida,
            idforma: me.idforma,
            idmaterial: me.idmaterial,
            idgiro: me.idgiro,
            imagen: me.imagen == "" ? me.imagenxdefec : me.imagen,
            codigo_barra: me.codigo_barra,
            codigo_repuesto: me.codigo_repuesto,
            codigo_equivalencia: me.codigo_equivalencia,
            interior: me.interior,
            exterior: me.exterior,
            altura: me.altura,
            stock_minimo: parseInt(me.stock_minimo),
            descripcion: me.descripcion,
            compatibilidad: me.compatibilidad,
            procedencia: me.procedencia,
            idprod_sunat: me.idprod_sunat,
            precio_unit_compras: me.precio_unit_compras,
            precio_unit_comprad: me.precio_unit_comprad,

            utilidad_publico:
              me.utilidad_publico == "" ? 0 : me.utilidad_publico,
            precio_publico: me.precio_publico == "" ? 0 : me.precio_publico,

            utilidad_tiendas:
              me.utilidad_tiendas == "" ? 0 : me.utilidad_tiendas,
            precio_tiendas: me.precio_tiendas == "" ? 0 : me.precio_tiendas,

            utilidad_distribuidor:
              me.utilidad_distribuidor == "" ? 0 : me.utilidad_distribuidor,
            precio_distribuidor:
              me.precio_distribuidor == "" ? 0 : me.precio_distribuidor,
          })

          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeRepuesto = error.response.data;
            me.limpiarAlertaError();
          });
      } else {
        axios
          .post("api/Repuestos/Crear", {
            idcategoria: me.idcategoria,
            idmarca_repuesto: me.idmarca_repuesto,
            idmarca_vehiculo: me.idmarca_vehiculo,
            idunidad_medida: me.idunidad_medida,
            idforma: me.idforma,
            idmaterial: me.idmaterial,
            idgiro: me.idgiro,
            imagen: me.imagen == "" ? me.imagenxdefec : me.imagen,
            codigo_barra: me.codigo_barra,
            codigo_repuesto: me.codigo_repuesto,
            codigo_equivalencia: me.codigo_equivalencia,
            interior: me.interior,
            exterior: me.exterior,
            altura: me.altura,
            stock_minimo: parseInt(me.stock_minimo),
            descripcion: me.descripcion,
            compatibilidad: me.compatibilidad,
            procedencia: me.procedencia,
            idprod_sunat: me.idprod_sunat,
            precio_unit_compras: me.precio_unit_compras,
            precio_unit_comprad: me.precio_unit_comprad,
            utilidad_publico:
              me.utilidad_publico == "" ? 0 : me.utilidad_publico,
            precio_publico: me.precio_publico == "" ? 0 : me.precio_publico,

            utilidad_tiendas:
              me.utilidad_tiendas == "" ? 0 : me.utilidad_tiendas,
            precio_tiendas: me.precio_tiendas == "" ? 0 : me.precio_tiendas,

            utilidad_distribuidor:
              me.utilidad_distribuidor == "" ? 0 : me.utilidad_distribuidor,
            precio_distribuidor:
              me.precio_distribuidor == "" ? 0 : me.precio_distribuidor,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeRepuesto = error.response.data;
            me.limpiarAlertaError();
          });
      }
    },

    buscarImagen(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal = e.target.result; // Visualizamos en Base64 al usuario despues de cargar imagen
        };

        // Reducimos imagen con un ancho de 300px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes =
              dataURI.split(",")[0].indexOf("base64") >= 0
                ? atob(dataURI.split(",")[1])
                : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            return dataUrl;
            //return dataURItoBlob(dataUrl);
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 300,
        })
          .then((resizedImage) => {
            this.imagen = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },

    deleteItem(item) {
      let me = this;
      const respta = confirm(
        "¿Estás seguro de eliminar el repuesto con Cod. " +
        item.codigo_repuesto +
        "?"
      );
      if (respta) {
        axios
          .delete("api/Repuestos/Eliminar/" + item.idrepuesto)
          .then((response) => {
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            this.listar();
          })
          .catch(function (error) {
            me.alerta.snackbar = true;
            me.alerta.color = "error";
            me.alerta.text = error.response.data;
          });
      }
    },

    limpiarAlertaError() {
      setTimeout(() => {
        this.mensajeRepuesto = "";
      }, 3000);
    },

    editItem(item) {
      this.idrepuesto = item.idrepuesto;
      this.idcategoria = item.idcategoria;
      this.idmarca_repuesto = item.idmarca_repuesto;
      this.idmarca_vehiculo = item.idmarca_vehiculo;
      this.idunidad_medida = item.idunidad_medida;
      this.idforma = item.idforma;
      this.idmaterial = item.idmaterial;
      this.idgiro = item.idgiro;
      this.imagen = item.imagen;
      this.codigo_barra = item.codigo_barra;
      this.codigo_repuesto = item.codigo_repuesto;
      this.codigo_equivalencia = item.codigo_equivalencia;
      this.interior = item.interior;
      this.exterior = item.exterior;
      this.altura = item.altura;
      this.stock_minimo = item.stock_minimo;
      this.descripcion = item.descripcion;
      this.compatibilidad = item.compatibilidad;
      this.procedencia = item.procedencia;
      this.idprod_sunat = item.idprod_sunat;
      this.precio_unit_compras = item.precio_unit_compras.toFixed(4);
      this.precio_unit_comprad = item.precio_unit_comprad.toFixed(4);
      this.utilidad_publico = item.utilidad_publico.toFixed(4);
      this.precio_publico = item.precio_publico.toFixed(2);
      this.utilidad_tiendas = item.utilidad_tiendas.toFixed(4);
      this.precio_tiendas = item.precio_tiendas.toFixed(2);
      this.utilidad_distribuidor = item.utilidad_distribuidor.toFixed(4);
      this.precio_distribuidor = item.precio_distribuidor.toFixed(2);
      this.selectProdSunat(item.idprod_sunat);
      this.editedIndex = 1;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.idrepuesto = "";
      this.idcategoria = "";
      this.idmarca_repuesto = "";
      this.idmarca_vehiculo = "";
      this.idunidad_medida = "";
      this.idforma = "";
      this.idmaterial = "";
      this.idgiro = "";
      this.imagen = "";
      this.codigo_barra = "";
      this.codigo_repuesto = "";
      this.codigo_equivalencia = "";
      this.interior = "";
      this.exterior = "";
      this.altura = "";
      this.stock_minimo = "";
      this.descripcion = "";
      this.compatibilidad = "";
      this.procedencia = "";
      this.idprod_sunat = "";
      this.precio_unit_compras = (0).toFixed(4);
      this.precio_unit_comprad = (0).toFixed(4);
      this.utilidad_publico = (0).toFixed(4);
      this.precio_publico = (0).toFixed(2);
      this.utilidad_tiendas = (0).toFixed(4);
      this.precio_tiendas = (0).toFixed(2);
      this.utilidad_distribuidor = (0).toFixed(4);
      this.precio_distribuidor = (0).toFixed(2);

      this.prod_sunats = []; // Limpiamos array

      this.mensajeRepuesto = "";
      this.editedIndex = -1;
      this.file = null;
      this.urlTemporal = "";
      // Limpiamos input carga de imagen
      //document.getElementById("file").value = [];
    },

    desactivar() {
      let me = this;

      axios
        .put("api/Repuestos/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.codigo_repuesto;
      this.adId = item.idrepuesto;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },

    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    activar() {
      let me = this;

      axios
        .put("api/Repuestos/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Desactivar, activar repuesto */

    crearPDF() {
      var columns = [
        { header: "COD.REPUESTO", dataKey: "codigo_repuesto" },
        { header: "DESCRIPCIÓN", dataKey: "descripcion" },
        { header: "CATEGORÍA", dataKey: "categoria" },
        { header: "MARCA", dataKey: "marca_repuesto" },
        { header: "VEHÍCULO", dataKey: "marca_vehiculo" },
        { header: "MODELOS", dataKey: "compatibilidad" },

        { header: "TP", dataKey: "forma" },
        { header: "MT", dataKey: "material" },
        { header: "GR", dataKey: "giro" },

        { header: "INT", dataKey: "interior" },
        { header: "EXT", dataKey: "exterior" },
        { header: "ALT", dataKey: "altura" },
        { header: "PROCEDENCIA", dataKey: "procedencia" },
        { header: "C", dataKey: "condicion" },
      ];
      var body = [];

      this.repuestos.map(function (x) {
        body.push({
          codigo_repuesto: x.codigo_repuesto,
          descripcion: x.descripcion,
          categoria: x.categoria,
          marca_repuesto: x.marca_repuesto,
          marca_vehiculo: x.marca_vehiculo,
          compatibilidad: x.compatibilidad,

          interior: x.interior,
          exterior: x.exterior,
          altura: x.altura,
          forma: x.forma,
          material: x.material,
          giro: x.giro,
          procedencia: x.procedencia,
          condicion: x.condicion == 1 ? "A" : "I",
        });
      });

      //console.log(body);

      // Agregar Encabezado: titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "LISTADO DE REPUESTOS",
            doc.internal.pageSize.width / 2,
            45,
            {
              align: "center",
            }
          );
          doc.addImage(imgData, "JPEG", 40, 17, 80, 40);
        }
      };
      // Agregar pie de pagina: numeracion
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "italic");
        doc.setFontSize(7);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "Pagina " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            570,
            {
              align: "center",
            }
          );
        }
      };

      var imgData = "data:image/png;base64," + this.logo;
      var doc = new jsPDF("l", "pt");

      doc.autoTable({
        columns,
        body,
        margin: { top: 70 },
        styles: { overflow: "ellipsize", cellWidth: "wrap" },
        headStyles: {
          fillColor: [46, 78, 121],
          fontSize: 7,
          halign: "center",
        },
        bodyStyles: { textColor: 0, fontSize: 6 },

        columnStyles: {
          codigo_repuesto: { cellWidth: 70 },
          descripcion: { cellWidth: 186 },
          categoria: { cellWidth: 60 },
          marca_repuesto: { cellWidth: 50 },
          marca_vehiculo: { cellWidth: 55 },
          compatibilidad: { cellWidth: 80 },
          interior: { cellWidth: 30 },
          exterior: { cellWidth: 30 },
          altura: { cellWidth: 30 },
          forma: { cellWidth: 30 },
          material: { cellWidth: 30 },
          giro: { cellWidth: 30 },
          procedencia: { cellWidth: 60.89 },
          condicion: { cellWidth: 20, halign: "center" },
        },
      });
      // 761.89 ancho hoja
      addHeaders(doc);
      addFooters(doc);
      doc.save("Repuestos.pdf");
    },

    crearXLSX() {
      var rows = [];

      this.repuestos.map(function (x) {
        rows.push({
          "Cód. repuesto": x.codigo_repuesto,
          "Cód. equivalencia": x.codigo_equivalencia,
          "Cód. barras": x.codigo_barra,
          Categoría: x.categoria,
          "Marca repuesto": x.marca_repuesto,
          "Marca vehículo": x.marca_vehiculo,
          "Modelos compatibles": x.compatibilidad,
          Tipo: x.forma,
          Material: x.material,
          Giro: x.giro,
          Interior: x.interior,
          Exterior: x.exterior,
          Altura: x.altura,
          "Stock Minimo": x.stock_minimo,
          Descripción: x.descripcion,
          Procedencia: x.procedencia,

          "Utilidad Publico": x.utilidad_publico,
          "P/U/Publico": x.precio_publico,

          "Utilidad Tiendas": x.utilidad_tiendas,
          "P/U/Tiendas": x.precio_tiendas,

          "Utilidad Distribuidor": x.utilidad_distribuidor,
          "P/U/Distribuidor": x.precio_distribuidor,

          Condición: x.condicion == 1 ? "A" : "I",
        });
      });

      var Repuesto = XLSX.utils.json_to_sheet(rows);

      var wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, Repuesto, "repuestos");

      XLSX.writeFile(wb, "Lista Repuestos.xlsx");
    },
  },
};
</script>